const LIMECHAT_WHATSAPP_SCRIPT_ID = 'limechat-whatsapp-widget-script';
const LIMECHAT_WHATSAPP_SCRIPT_URL =
  'https://s3.ap-south-1.amazonaws.com/cdn.limechat.ai/packs/js/whatsapp_widget/lc_wa_widget.js';
const WHATSAPP_FALLBACK_ICON_URL =
  'https://media.limechat.in/lcmedia/assets/images/whatsapp/LC_WA.png';
const BROKEN_ICON_HOST = 'limechats3.s3.ap-south-1.amazonaws.com';

const WIDGET_CONFIG = {
  accessToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZSI6IjkxOTEzNjQzNjc3NiIsImlhdCI6MTc4MTA4NDAxNn0.GsFeJennuOrMJS5HYFHYNzLA5jR03L58zpGuH6gjPcI',
  phoneNumber: '919136436776',
};

const WHATSAPP_ICON_SIZE = 56;
const ICON_GAP = 10;
const FALLBACK_BOTTOM = 20;
const FALLBACK_RIGHT = 96;

function bridgeLimeChatWhatsappCtor() {
  if (typeof window.LimeChatWhatsapp === 'function') {
    return window.LimeChatWhatsapp;
  }

  const bridgeScript = document.createElement('script');
  bridgeScript.textContent =
    'try{if(typeof LimeChatWhatsapp==="function"){window.LimeChatWhatsapp=LimeChatWhatsapp;}}catch(e){}';
  document.head.appendChild(bridgeScript);
  bridgeScript.remove();

  return typeof window.LimeChatWhatsapp === 'function'
    ? window.LimeChatWhatsapp
    : null;
}

function getLimeChatLauncher() {
  const nodes = Array.from(
    document.querySelectorAll('.woot-widget-bubble, button.woot-widget-bubble')
  );
  const launchers = nodes.filter((el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.width > 20 &&
      rect.width <= 88 &&
      rect.height > 20 &&
      rect.height <= 88 &&
      rect.bottom > 0 &&
      rect.right > 0
    );
  });

  if (!launchers.length) {
    return null;
  }

  return launchers.sort((a, b) => {
    const ra = a.getBoundingClientRect();
    const rb = b.getBoundingClientRect();
    return rb.bottom + rb.right - (ra.bottom + ra.right);
  })[0];
}

function disableWhatsappScrollHide() {
  const instance = window.__limeChatWhatsappInstance;
  if (instance && !instance.__bxiNoScrollHide) {
    instance.__bxiNoScrollHide = true;
    instance.hideWidgetWithTransition = function noopHide() {};
    instance.showWidgetWithTransition = function keepVisible() {
      const el = this.widgetContainer;
      if (!el) return;
      el.style.display = 'flex';
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.transform = 'none';
    };
  }

  const Ctor = window.LimeChatWhatsapp;
  if (Ctor?.prototype && !Ctor.prototype.__bxiNoScrollHide) {
    Ctor.prototype.__bxiNoScrollHide = true;
    Ctor.prototype.hideWidgetWithTransition = function noopHide() {};
  }
}

function injectWhatsappIconOnlyStyles() {
  const styleId = 'bxi-whatsapp-icon-only-style';
  let style = document.getElementById(styleId);
  if (!style) {
    style = document.createElement('style');
    style.id = styleId;
    document.head.appendChild(style);
  }

  style.textContent = `
    .WhatsAppButton__root {
      position: fixed !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: ${WHATSAPP_ICON_SIZE}px !important;
      min-width: ${WHATSAPP_ICON_SIZE}px !important;
      max-width: ${WHATSAPP_ICON_SIZE}px !important;
      height: ${WHATSAPP_ICON_SIZE}px !important;
      padding: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      border: none !important;
      overflow: visible !important;
      font-size: 0 !important;
      line-height: 0 !important;
      gap: 0 !important;
      left: auto !important;
      transform: none !important;
      opacity: 1 !important;
      visibility: visible !important;
      transition: none !important;
    }
    .WhatsAppButton__root .landbot-whatsapp__button {
      width: ${WHATSAPP_ICON_SIZE}px !important;
      height: ${WHATSAPP_ICON_SIZE}px !important;
      min-width: ${WHATSAPP_ICON_SIZE}px !important;
      padding: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      border: none !important;
      border-radius: 0 !important;
      overflow: visible !important;
      font-size: 0 !important;
      gap: 0 !important;
      transform: none !important;
    }
    .WhatsAppButton__root span,
    .WhatsAppButton__root p,
    .WhatsAppButton__root label,
    .WhatsAppButton__root .whatsapp__poweredBy {
      display: none !important;
    }
    .WhatsAppButton__root img {
      width: ${WHATSAPP_ICON_SIZE}px !important;
      height: ${WHATSAPP_ICON_SIZE}px !important;
      margin: 0 !important;
      padding: 0 !important;
      display: block !important;
      object-fit: contain !important;
      background: transparent !important;
    }
  `;
}

/** React StrictMode / HMR can call initializeWidget() twice — keep a single button. */
function dedupeWhatsappButtons() {
  const buttons = document.querySelectorAll('.WhatsAppButton__root');
  if (buttons.length <= 1) {
    return buttons[0] || null;
  }

  const keep = buttons[buttons.length - 1];
  buttons.forEach((button, index) => {
    if (index < buttons.length - 1) {
      button.remove();
    }
  });
  return keep;
}

function collapseWhatsappLabelToIcon(button) {
  button.querySelectorAll('span, p, label').forEach((el) => {
    if (el.querySelector('img')) return;
    el.style.setProperty('display', 'none', 'important');
  });
}

function fixWhatsappWidgetIcon(button) {
  const img = button.querySelector('img');
  if (!img) {
    return false;
  }

  const applyFallback = () => {
    if (img.src !== WHATSAPP_FALLBACK_ICON_URL) {
      img.src = WHATSAPP_FALLBACK_ICON_URL;
    }
  };

  img.addEventListener('error', applyFallback, { once: true });

  if (
    img.src.includes(BROKEN_ICON_HOST) ||
    (img.complete && img.naturalWidth === 0)
  ) {
    applyFallback();
  }

  return true;
}

function lockWhatsappOnScreen(button) {
  const pin = (prop, value) => {
    if (button.style.getPropertyValue(prop) !== value) {
      button.style.setProperty(prop, value, 'important');
    }
  };
  pin('position', 'fixed');
  pin('transform', 'none');
  pin('translate', 'none');
  pin('opacity', '1');
  pin('visibility', 'visible');
  pin('display', 'flex');
  pin('transition', 'none');
}

function layoutWhatsappBesideLimeChat(button) {
  lockWhatsappOnScreen(button);
  button.style.setProperty('z-index', '2147483646', 'important');
  button.style.setProperty('left', 'auto', 'important');

  const launcher = getLimeChatLauncher();
  if (launcher) {
    const rect = launcher.getBoundingClientRect();
    const right = Math.max(
      8,
      Math.round(window.innerWidth - rect.left + ICON_GAP)
    );
    const bottom = Math.max(
      8,
      Math.round(
        window.innerHeight -
          rect.bottom +
          (rect.height - WHATSAPP_ICON_SIZE) / 2
      )
    );

    button.style.setProperty('right', `${right}px`, 'important');
    button.style.setProperty('bottom', `${bottom}px`, 'important');
    return true;
  }

  button.style.setProperty('right', `${FALLBACK_RIGHT}px`, 'important');
  button.style.setProperty('bottom', `${FALLBACK_BOTTOM}px`, 'important');
  return false;
}

function observeWhatsappButton(button) {
  if (button.dataset.bxiObserved === 'true') {
    return;
  }
  button.dataset.bxiObserved = 'true';

  let locking = false;
  const observer = new MutationObserver(() => {
    if (locking) return;
    locking = true;
    lockWhatsappOnScreen(button);
    locking = false;
  });
  observer.observe(button, { attributes: true, attributeFilter: ['style'] });
}

let stayVisibleBound = false;
function bindWhatsappStayVisible() {
  if (stayVisibleBound) return;
  stayVisibleBound = true;
  disableWhatsappScrollHide();

  const pin = () => {
    disableWhatsappScrollHide();
    const button = document.querySelector('.WhatsAppButton__root');
    if (!button) return;
    observeWhatsappButton(button);
    layoutWhatsappBesideLimeChat(button);
  };

  window.addEventListener('scroll', pin, { passive: true });
  window.addEventListener('resize', pin);
}

function ensureWhatsappWidgetVisible() {
  const button = dedupeWhatsappButtons();
  if (!button) {
    return false;
  }

  disableWhatsappScrollHide();
  fixWhatsappWidgetIcon(button);
  collapseWhatsappLabelToIcon(button);
  observeWhatsappButton(button);
  const aligned = layoutWhatsappBesideLimeChat(button);
  bindWhatsappStayVisible();
  return aligned;
}

function scheduleWhatsappWidgetLayout() {
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (ensureWhatsappWidgetVisible() || attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 400);
}

function runWhatsappWidgetInit() {
  const Ctor = bridgeLimeChatWhatsappCtor();
  if (!Ctor) {
    return false;
  }

  disableWhatsappScrollHide();

  if (window.__limeChatWhatsappInitialized) {
    scheduleWhatsappWidgetLayout();
    return true;
  }

  if (window.__limeChatWhatsappInitPromise) {
    return true;
  }

  if (!window.__limeChatWhatsappInstance) {
    window.__limeChatWhatsappInstance = new Ctor(WIDGET_CONFIG);
    disableWhatsappScrollHide();
  }

  window.__limeChatWhatsappInitPromise = window.__limeChatWhatsappInstance
    .initializeWidget()
    .then(() => {
      window.__limeChatWhatsappInitialized = true;
      disableWhatsappScrollHide();
      dedupeWhatsappButtons();
      scheduleWhatsappWidgetLayout();
    })
    .catch((error) => {
      window.__limeChatWhatsappInitPromise = null;
      console.error('[WhatsApp Widget] Failed to initialize widget', error);
    });

  return true;
}

export default function initializeLimeChatWhatsapp() {
  if (typeof window === 'undefined') {
    return;
  }

  injectWhatsappIconOnlyStyles();

  const tryInit = () => {
    if (!runWhatsappWidgetInit()) {
      console.error(
        '[WhatsApp Widget] Script loaded but LimeChatWhatsapp constructor was not found'
      );
    }
  };

  if (runWhatsappWidgetInit()) {
    return;
  }

  const existingScript = document.getElementById(LIMECHAT_WHATSAPP_SCRIPT_ID);
  if (existingScript) {
    if (existingScript.dataset.loaded === 'true') {
      tryInit();
      return;
    }
    existingScript.addEventListener('load', tryInit, { once: true });
    return;
  }

  const script = document.createElement('script');
  script.id = LIMECHAT_WHATSAPP_SCRIPT_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.src = LIMECHAT_WHATSAPP_SCRIPT_URL;
  script.onload = () => {
    script.dataset.loaded = 'true';
    tryInit();
  };
  script.onerror = () => {
    console.error('[WhatsApp Widget] Failed to load lc_wa_widget.js');
  };

  document.head.appendChild(script);
}
